import {
  IInvoice,
  IGetInvoiceResponse,
  ISearchInvoicesResponse,
  ISearchInvoicesRequest,
  IInvoiceBeginResponse,
  IInvoiceSaveDraftResponse,
  IInvoiceSaveDraftRequest,
  ISubmitInvoiceResponse,
  IVoidInvoiceResponse,
 INotifyInvoiceResponse,
 INotifyInvoiceRequest,
 PostToQuickbooksRequest,
 PostToQuickbooksResponse,
 ResetInvoiceStatusRequest,
 ResetInvoiceStatusResponse,
} from "@/interfaces";
import { AxiosResponse } from "axios";
import Vue from "vue";


export const ResetInvoiceStatus = async (
  data: ResetInvoiceStatusRequest
): Promise<ResetInvoiceStatusResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoice-reset",
    },
  });
  return resp.data;
};



export const NotifyInvoice = async (
  data: INotifyInvoiceRequest
): Promise<INotifyInvoiceResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoice-send",
    },
  });
  return resp.data;
};


export const PostToQuickbooks = async (
  data: PostToQuickbooksRequest
): Promise<PostToQuickbooksResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoice-post-to-quickbooks",
    },
  });
  return resp.data;
};



export const SubmitInvoice = async (
  data: IInvoice
): Promise<ISubmitInvoiceResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoices-save",
    },
  });
  return resp.data;
};

export const GetInvoices = async (
  data: ISearchInvoicesRequest
): Promise<ISearchInvoicesResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoices-search",
    },
  });
  return resp.data;
};

export const InvoiceBegin = async (): Promise<IInvoiceBeginResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {},
    params: {
      action: "invoices-begin",
    },
  });
  return resp.data;
};

export const InvoiceSaveDraft = async (
  data: IInvoiceSaveDraftRequest
): Promise<IInvoiceSaveDraftResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "invoices-save-draft",
    },
  });
  return resp.data;
};

export const GetInvoice = async (id: string): Promise<IGetInvoiceResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {
      InvoiceNumber: id,
    },
    params: {
      action: "invoices-get",
    },
  });
  return resp.data;
};

export const VoidInvoice = async (
  id: string
): Promise<IVoidInvoiceResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {
      InvoiceNumber: id,
    },
    params: {
      action: "invoices-void",
    },
  });
  return resp.data;
};



